"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineCreateDrawer = InlineCreateDrawer;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const yup_1 = require("@hookform/resolvers/yup");
const FormContext_1 = require("./FormContext");
const CommonComponentsController_1 = require("../Resultsets/CommonComponentsController");
const ErrorBoundary_1 = __importDefault(require("./ErrorBoundary"));
const ToolsFetch_1 = __importDefault(require("../../React/Tools/ToolsFetch"));
function InlineCreateDrawer({ show, onHide, title, repository, ModalBodyComponent, makeValidationSchema, contextData, additionalModalBodyProps, onCreated, isEditing = false, initialData, onEdited, headerBadge, }) {
    const [errorMessage, setErrorMessage] = (0, react_1.useState)("");
    const [requestPending, setRequestPending] = (0, react_1.useState)(false);
    const formMethods = (0, react_hook_form_1.useForm)({
        defaultValues: {},
        mode: "onChange",
        resolver: makeValidationSchema ? (0, yup_1.yupResolver)(makeValidationSchema(isEditing)) : undefined,
    });
    // Czyść stan formularza i komunikaty przy każdym otwarciu/zamknięciu panelu.
    // W trybie tworzenia reset do pustego; w trybie edycji body-component sam
    // wypełni formularz przez swój własny useEffect z initialData.
    (0, react_1.useEffect)(() => {
        setErrorMessage("");
        setRequestPending(false);
        if (show && !isEditing)
            formMethods.reset({});
    }, [show]);
    async function handleSubmitRepository(data) {
        try {
            if (!repository)
                throw new Error("Repository nie został przekazany do panelu");
            setErrorMessage("");
            setRequestPending(true);
            if (isEditing) {
                // Scala initialData (zawiera id i pola nie pokazywane w formularzu)
                // z danymi formularza (zmiany wprowadzone przez użytkownika).
                const itemToEdit = { ...initialData, ...data };
                const editedItem = (await repository.editItem(itemToEdit));
                onEdited?.(editedItem);
                onHide();
                return;
            }
            // Traktuj pole pliku jako "obecne" tylko gdy faktycznie wybrano plik
            // (zgodnie z logiką GeneralModal).
            const hasFiles = Object.values(data).some((value) => {
                if (value instanceof FileList)
                    return value.length > 0;
                if (value instanceof File)
                    return true;
                return false;
            });
            let requestData;
            if (hasFiles) {
                requestData = (0, CommonComponentsController_1.parseFieldValuestoFormData)(data);
                requestData.append("_contextData", JSON.stringify(contextData));
            }
            else {
                requestData = { ...data, _contextData: contextData };
            }
            const newItem = (await repository.addNewItem(requestData));
            onCreated?.(newItem);
            onHide();
        }
        catch (error) {
            if (error instanceof Error)
                setErrorMessage(error.message);
            ToolsFetch_1.default.sendClientErrorReport(error, {
                repositoryName: repository?.name,
                action: isEditing ? "InlineCreateDrawer_handleSubmit_edit" : "InlineCreateDrawer_handleSubmit_add",
                drawerTitle: title,
            });
        }
        finally {
            setRequestPending(false);
        }
    }
    return (react_1.default.createElement(react_bootstrap_1.Offcanvas, { show: show, onHide: onHide, placement: "end", backdrop: false, scroll: true, 
        // zIndex ponad warstwami Bootstrap modala (backdrop ~1050, modal ~1055), aby panel
        // nie był przyciemniany przez backdrop pisma ANI nie był przez modal przechwytywany
        // (modal trapuje pointer-events). Dzięki temu host pozostaje widoczny, a panel klikalny.
        style: { width: 420, zIndex: 1060 } },
        react_1.default.createElement(ErrorBoundary_1.default, null,
            react_1.default.createElement(react_bootstrap_1.Form, { onSubmit: (e) => { e.stopPropagation(); formMethods.handleSubmit(handleSubmitRepository)(e); } },
                react_1.default.createElement(react_bootstrap_1.Offcanvas.Header, { closeButton: true },
                    react_1.default.createElement("div", { className: "d-flex flex-wrap align-items-center gap-2" },
                        react_1.default.createElement(react_bootstrap_1.Offcanvas.Title, null, title),
                        headerBadge)),
                react_1.default.createElement(react_bootstrap_1.Offcanvas.Body, null,
                    react_1.default.createElement(FormContext_1.FormProvider, { value: formMethods },
                        react_1.default.createElement(ModalBodyComponent, { isEditing: isEditing, initialData: initialData, contextData: contextData, additionalProps: additionalModalBodyProps }),
                        errorMessage && (react_1.default.createElement(react_bootstrap_1.Alert, { style: { whiteSpace: "pre-wrap" }, className: "mt-3", variant: "danger", onClose: () => setErrorMessage(""), dismissible: true }, errorMessage))),
                    react_1.default.createElement("div", { className: "text-end mt-3" },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", className: "me-2", onClick: onHide }, "Anuluj"),
                        react_1.default.createElement(react_bootstrap_1.Button, { type: "submit", variant: "primary", disabled: !formMethods.formState.isValid || requestPending },
                            react_1.default.createElement("span", { className: "d-inline-flex align-items-center" },
                                "Zapisz",
                                requestPending && (react_1.default.createElement(react_bootstrap_1.Spinner, { as: "span", animation: "border", size: "sm", role: "status", "aria-hidden": "true", className: "ms-2" }))))))))));
}
